import { useState, useEffect } from 'react';
import { Download, X } from 'lucide-react';
import { Button } from './ui/button';

export const InstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (localStorage.getItem('pwa_install_dismissed')) return;

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') setDeferredPrompt(null);
  };

  const handleDismiss = () => {
    setDismissed(true);
    localStorage.setItem('pwa_install_dismissed', 'true');
  };

  if (!deferredPrompt || dismissed) return null;

  return (
    <div className="fixed bottom-20 left-4 right-4 sm:left-auto sm:right-4 sm:w-80 z-50 animate-in slide-in-from-bottom-4 duration-300" data-testid="pwa-install-banner">
      <div className="bg-background border border-border rounded-xl shadow-lg p-4">
        <div className="flex items-start gap-3">
          <img src="/brand/logo-icon.png" alt="ConnectMail" className="w-10 h-10 rounded-lg bg-white p-0.5 flex-shrink-0" />
          <div className="flex-1 min-w-0">
            <p className="text-sm font-semibold">Install ConnectMail</p>
            <p className="text-xs text-muted-foreground mt-0.5">Add to home screen for quick access</p>
          </div>
          <button onClick={handleDismiss} className="text-muted-foreground hover:text-foreground p-0.5" data-testid="pwa-dismiss-btn">
            <X className="w-4 h-4" />
          </button>
        </div>
        <Button onClick={handleInstall} className="w-full mt-3 h-9 text-sm gap-2" data-testid="pwa-install-btn">
          <Download className="w-4 h-4" />Install App
        </Button>
      </div>
    </div>
  );
};
